import { render, staticRenderFns } from "./3d-animation-viewer.vue?vue&type=template&id=fffa1a7e&"
import script from "./3d-animation-viewer.vue?vue&type=script&lang=js&"
export * from "./3d-animation-viewer.vue?vue&type=script&lang=js&"
import style0 from "./3d-animation-viewer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports